import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { SupportedLocale } from '../types';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from '../types';

export function useLocale() {
  const { i18n } = useTranslation();

  const currentLocale = (
    SUPPORTED_LOCALES.includes(i18n.language as SupportedLocale)
      ? i18n.language
      : DEFAULT_LOCALE
  ) as SupportedLocale;

  const setLocale = useCallback(
    async (locale: SupportedLocale) => {
      await i18n.changeLanguage(locale);
      localStorage.setItem('i18nextLng', locale);
    },
    [i18n]
  );

  return {
    locale: currentLocale,
    setLocale,
    supportedLocales: SUPPORTED_LOCALES,
  };
}
